import styled from 'styled-components';
import { Button as ButtonLayoutComponent } from '@playbookux/playbook-web-core';

export const FieldContainer = styled.div`
  display: flex;
  align-items: center;
  margin-top: 5px;

  input {
    max-width: 280px !important;
    height: 39px;
    background-color: ${({ theme }) => theme.color.white};
    border: 1px solid ${({ theme }) => theme.color.inputBorder};
  }
`;

export const Button = styled(ButtonLayoutComponent)`
  width: 60px;
  height: 39px;
  border-top-left-radius: 0 !important;
  border-bottom-left-radius: 0 !important;
`;
